import { api } from "@/lib/api";

export interface AdminNotificationPreferences {
  systemAlerts: boolean;
  contentReviews: boolean;
  weeklyReports: boolean;
}

const BASE_URL = "/admin/me/notification-preferences";

export const notificationPreferencesService = {
  get(): Promise<AdminNotificationPreferences> {
    return api.get<AdminNotificationPreferences>(BASE_URL);
  },
  update(
    patch: Partial<AdminNotificationPreferences>,
  ): Promise<AdminNotificationPreferences> {
    return api.patch<AdminNotificationPreferences>(BASE_URL, patch);
  },
};
